import { render } from "./diffcommitviewer.vue?vue&type=template&id=184eb926&scoped=true"
import script from "./diffcommitviewer.vue?vue&type=script&lang=js"
export * from "./diffcommitviewer.vue?vue&type=script&lang=js"

import "./diffcommitviewer.vue?vue&type=style&index=0&id=184eb926&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-184eb926"]])

export default __exports__